const LOYALTY_MINIMUM_AGE_YEARS = 15;
const DEFAULT_MAX_DATE_OFFSET_DAYS = 90;

/**
 * Display format is per-market, the submitted value never is — otherwise a CA date reads back
 * with day and month swapped.
 * @param {Date} date
 * @returns {string} `dd/mm/yyyy`
 */
const toWireDate = (date) =>
  [
    String(date.getDate()).padStart(2, '0'),
    String(date.getMonth() + 1).padStart(2, '0'),
    date.getFullYear(),
  ].join('/');

class CoreDatepicker extends HTMLElement {
  /** @type {any} */
  #datePicker = null;

  connectedCallback() {
    const datepickerInput = this.querySelector('input');
    if (!datepickerInput) return;

    // Degrade to a plain readonly field rather than throwing if flatpickr didn't load
    this.#datePicker = window.flatpickr?.(datepickerInput, {
      maxDate: this.#maxDate(),
      minDate: this.dataset.minDate || undefined,
      disableMobile: true,
      dateFormat:
        this.dataset.dateFormat ||
        window?.Theme?.translations?.recipient_form_date_format ||
        'd/m/Y',
      onReady: this.#syncWireValue,
      onChange: this.#syncWireValue,
    });
  }

  disconnectedCallback() {
    this.#datePicker?.destroy();
    this.#datePicker = null;
  }

  #maxDate = () => {
    const maxDate = new Date();

    // Loyalty has a minimum age — stricter than "not in the future"
    if (this.dataset.isLoyalty === 'true') {
      maxDate.setFullYear(maxDate.getFullYear() - LOYALTY_MINIMUM_AGE_YEARS);
      return maxDate;
    }

    if (this.dataset.maxDate) return this.dataset.maxDate;

    maxDate.setDate(maxDate.getDate() + DEFAULT_MAX_DATE_OFFSET_DAYS);
    return maxDate;
  };

  #syncWireValue = (
    /** @type {Date[]} */ selectedDates,
    /** @type {string} */ _dateStr,
    /** @type {any} */ instance,
  ) => {
    const [date] = selectedDates;

    if (date) {
      instance.input.dataset.value = toWireDate(date);
    } else {
      delete instance.input.dataset.value;
    }
  };
}

if (!customElements.get('core-datepicker')) {
  customElements.define('core-datepicker', CoreDatepicker);
}
